import * as yup from 'yup';

export const loadSchema = yup
  .number()
  .typeError('This field must be a number')
  .required('This field cannot be empty')
  .test('min-digits', 'Load number must have at least 6 digits', (value) => {
    return value.toString().length >= 6;
  });
